//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DepartmentMixin from '@/views/mixins/guide/DepartmentMixin'

export default {
  name: 'Department',
  mixins: [DepartmentMixin]
}



// WEBPACK FOOTER //
// ./src/views/guide/vistel/Department.vue